module.exports = __webpack_public_path__ + "img/motorcycle.5df7ff7b.png";